class DroplandHeaderMarquee extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-dropland-marquee-track]');
    this.source = this.querySelector('[data-dropland-marquee-source]');
    if (!this.track || !this.source) return;

    this.rebuild();
    this.resizeObserver = new ResizeObserver(() => this.rebuild());
    this.resizeObserver.observe(this);
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }

  rebuild() {
    this.track.querySelectorAll('[data-dropland-marquee-clone]').forEach((clone) => clone.remove());
    const sourceWidth = this.source.getBoundingClientRect().width;
    if (!sourceWidth) return;

    const copies = Math.max(2, Math.ceil(this.getBoundingClientRect().width / sourceWidth) + 1);
    for (let index = 1; index < copies; index += 1) {
      const clone = this.source.cloneNode(true);
      clone.dataset.droplandMarqueeClone = '';
      clone.setAttribute('aria-hidden', 'true');
      this.track.append(clone);
    }
    this.style.setProperty('--dropland-marquee-loop-width', `${sourceWidth}px`);
  }
}

if (!customElements.get('dropland-header-marquee')) {
  customElements.define('dropland-header-marquee', DroplandHeaderMarquee);
}
